import { withDirectives as v, openBlock as t, createElementBlock as r, Fragment as p, renderList as m, normalizeClass as h, normalizeStyle as f, vShow as g } from "vue";
/* empty css                    */
/* empty css                    */
import k from "./design-system.es128.js";
const x = {
  name: "DsPlaceholder",
  props: {
    /**
     * Array of row objects with height of row and box columns
     */
    rows: {
      type: Array,
      default: () => []
    },
    /**
     * Show the loading placeholder or not
     */
    loading: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    computedRows() {
      return this.rows.reduce((o, s, l, n) => {
        const { height: i } = s;
        return o.push({
          boxes: s.boxes.reduce((e, a, c, d) => (e.push(a), c !== d.length - 1 && e.push({ type: "divider" }), e), []),
          height: i
        }), l !== n.length - 1 && o.push({ type: "divider" }), o;
      }, []);
    }
  }
}, b = { class: "animated-background" };
function $(o, s, l, n, i, e) {
  return v((t(), r("div", b, [
    (t(!0), r(p, null, m(e.computedRows, ({ height: a, type: c, boxes: d }, _) => (t(), r("div", {
      key: _,
      class: h(["row", [c]]),
      style: f({ height: a })
    }, [
      (t(!0), r(p, null, m(d, (u, y) => (t(), r("div", {
        key: y,
        class: h(["box", [u.type]]),
        style: f({ flex: `${u} 0 0` })
      }, null, 6))), 128))
    ], 6))), 128))
  ], 512)), [
    [g, l.loading]
  ]);
}
const A = /* @__PURE__ */ k(x, [["render", $], ["__scopeId", "data-v-30ce826a"]]);
export {
  A as default
};
//# sourceMappingURL=design-system.es87.js.map
